export { default as ContactModal } from "./ContactModal";
export type { ContactModalProps, HeaderContactDetails } from "./ContactModal";
